import type { JSX } from "react";
import { cn } from "./cn";

export interface ReplyBadgeProps {
  /** Badge label text */
  readonly label: string;
  /** Extra className */
  readonly className?: string;
}

/**
 * A small muted pill badge for reply indicators.
 */
export function ReplyBadge({ label, className }: ReplyBadgeProps): JSX.Element {
  return (
    <span
      className={cn(
        "bg-surface-hover text-content-tertiary text-[10px] rounded-full px-1.5 py-0.5 shrink-0",
        className,
      )}
    >
      {label}
    </span>
  );
}
